import type { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';

import { useFeatureFlags } from 'src/context/FeatureFlagsContext';
import { ROUTE_AUDITS } from 'src/v2/routes';
import { isRiskEngineEnabled } from '../availability';

interface RequireRiskEngineProps {
  readonly children: ReactNode;
}

/** Prevents a disabled Risk Engine page from being reached through a direct URL. */
export function RequireRiskEngine({ children }: RequireRiskEngineProps): JSX.Element {
  const flags = useFeatureFlags();
  if (!isRiskEngineEnabled(flags)) {
    return <Navigate to={ROUTE_AUDITS} replace />;
  }
  return <>{children}</>;
}
